import { render, staticRenderFns } from "./YagiprimeWrapper.vue?vue&type=template&id=1904847e&scoped=true"
import script from "./YagiprimeWrapper.vue?vue&type=script&lang=js"
export * from "./YagiprimeWrapper.vue?vue&type=script&lang=js"
import style0 from "./YagiprimeWrapper.vue?vue&type=style&index=0&id=1904847e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1904847e",
  null
  
)

export default component.exports